export interface PasswordRule {
  key: string;
  label: string;
  pattern: RegExp;
}

export const PASSWORD_RULES: PasswordRule[] = [
  { key: 'hasUppercase', label: 'Al menos 1 letra mayúscula', pattern: /[A-Z]/ },
  { key: 'hasLowercase', label: 'Al menos 1 letra minúscula', pattern: /[a-z]/ },
  { key: 'hasNumber', label: 'Al menos 1 número', pattern: /[0-9]/ },
  { key: 'hasSpecialChar', label: 'Al menos 1 carácter especial', pattern: /[!@#$%^&*()\-_+=\[\]{}|;:',.<>?/~`]/ },
  { key: 'minLength', label: '8 caracteres o más', pattern: /.{8,}/ },
];

export const PASSWORD_MAX_LENGTH = 64;
